<script setup lang="ts">
import FormCategoriaEspacoEvento from '../components/form-categoria-espaco-evento.vue'
import { useCategoriaEspacoEventoStore } from '../store/useCategoriaEspacoEventoStore'

definePage({
  meta: {
    navActiveLink: 'admin-categoria-espaco-evento',
    action: 'edit',
    subject: 'categoriaespacoevento',
  },
})

const store = useCategoriaEspacoEventoStore()
const router = useRouter()

const {
  fetchItem,
} = store

fetchItem(router.currentRoute.value.params.id)
</script>

<template>
  <FormCategoriaEspacoEvento is-editing />
</template>
